import { MotifFormField, MotifInput, MotifLabel } from "@ey-xd/motif-react";
interface InputBoxProps {
  ariaLabel?: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  prefix?: string | React.ReactNode;
  suffix?: string | React.ReactNode;
  readonly?: boolean;
  hideClearButton?: boolean;
  className?: string;
  name?: string;
  error?: {
    isError: boolean;
    message: string;
  };
  placeholder?: string;
  type?: "text" | "email" | "password" | "number";
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputBox: React.FC<InputBoxProps> = ({
  ariaLabel = "",
  label = "",
  name = "",
  onChange,
  onBlur,
  value,
  prefix = "",
  suffix = "",
  readonly = false,
  hideClearButton = false,
  className = "",
  error = { isError: false },
  placeholder = "Enter text",
  type = "text",
  required = false,
  onKeyDown,
}) => {
  const { isError } = error;
  return (
    <>
      <MotifFormField aria-label="Input" role="group">
        <MotifLabel aria-label="Input">
          {ariaLabel}
          {required && <span className="required">*</span>}
        </MotifLabel>
        <MotifInput
          aria-label="Input"
          ariaLabel="Input"
          id="input"
          label={label}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          prefix={prefix}
          suffix={suffix}
          disabled={readonly}
          hideClearButton={hideClearButton}
          className={className + (isError ? " motif-input-invalid" : "")}
          name={name}
          placeholder={placeholder}
          autoComplete="one-time-code"
          type={type}
          onKeyDown={onKeyDown}
        />
      </MotifFormField>
    </>
  );
};

export default InputBox;
